import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/5 bg-[#050505] py-12 px-5 md:px-12"
    >
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-[#D4AF37] font-bold text-black">
                C
              </span>
              <span className="text-sm font-semibold tracking-wide text-white">
                CAPITAL ACCESS <span className="text-[#D4AF37]">HUB</span>
              </span>
            </div>

            <p className="mt-4 max-w-md text-sm text-zinc-400">
              We help small businesses access fast, flexible funding through our
              vetted partner network.
            </p>

            <p
              data-testid="footer-powered-by"
              className="mt-3 text-xs text-zinc-500"
            >
              Powered by Melted Port Studios
            </p>
          </div>

          <div className="flex flex-col gap-3 text-sm">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-zinc-300 transition-colors hover:text-[#D4AF37]"
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-zinc-300 transition-colors hover:text-[#D4AF37]"
            >
              Terms of Service
            </Link>

            <a
              href="mailto:funding@meltedportstudios.com"
              data-testid="footer-contact-link"
              className="text-zinc-300 transition-colors hover:text-[#D4AF37]"
            >
              Contact
            </a>
          </div>
        </div>

        <div className="section-divider mt-10" />

        <div className="mt-6 flex flex-col gap-3 text-xs text-zinc-500 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-disclaimer">
            Capital Access Hub is not a lender. We connect businesses with funding partners.
          </p>

          <p
            data-testid="footer-referral-disclosure"
            className="max-w-xl text-zinc-600"
          >
            Capital Access Hub may receive a referral fee from funding partners.
            This does not affect your cost or available options.
          </p>

          <p>
            © {new Date().getFullYear()} Capital Access Hub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
